import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RamenDiningIcon(props: IconProps) {
    return <Icon {...props} iconKey={"ramen_dining"}/>
}
